import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { DataTable } from '../../table/Table';
import './MergeConsignmentModal.css';
import { mergeConsignment } from '../../../services/consignment/consignmentService';
import { toast } from 'react-toastify';
export const MergeConsignmentModal: React.FC<any> = (props) => {
    const [showModal, setShowModal] = useState(true);
    const [mergeId, setMergeId] = useState('');

    const columnDefinitions = {
        Consignment: [
            { label: 'ID', key: '_id' },
            { label: 'Consignment Group No', key: 'grpConsignmentID' },
            { label: 'Vehicle Reg. No.', key: 'vRegNo' },
            { label: 'Assigned Drivers', key: 'assignedDriver' },
            { label: 'Action', key: 'sStatus' },
        ],
    };
    const onClose = () => {
        setShowModal(false);
        // Notify parent to close the modal
        if (props.onClose) {
            props.onClose();
        }
    };
    const handleMergeConsignments = async (item: any) => {
        setMergeId(item._id);

        try {
            const payLoad = {
                sPrimaryConsignmentID: props.consignmentID,
                sMergeConsignmentIDs: [item._id],
            };
            const response = await mergeConsignment(payLoad);
            if ((response as any).status === 201||(response as any).status === 200) {
                toast.success('Consignment Merged successfully!', {
                    position: 'top-center',
                    theme: 'colored',
                });
                // Wait a bit for backend to process, then refresh
                setTimeout(async () => {
                    await props.reFetchConsignmentData();
                    setMergeId('');
                    onClose();
                }, 1500);
            }
        } catch (error: any) {
            console.error('Merge error:', error);
            toast.error(error?.response?.data?.message || 'Something went wrong', {
                position: 'top-center',
                theme: 'colored',
            });
            setMergeId('');
        }
    };
    return (
        <Modal show={showModal} onHide={onClose} contentClassName='modal-w-xxl'>
            <Modal.Header>
                <Modal.Title>Merge Consignment</Modal.Title>
            </Modal.Header>
            <Modal.Body className='modal-body'>
                <div className='table-parent'>
                    <DataTable
                        columnDefinitions={columnDefinitions.Consignment}
                        paginatedItems={props.pagination}
                        isLoading={showModal}
                        handleMerging={handleMergeConsignments}
                        tableFor='Consignment'
                        trackerColumn='sStatus'
                        hideActions={true}
                        mergeId={mergeId}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};
